<template>
  <div>
    <server-error :error="error" />
    <div v-if="isLoaded">
      <div v-if="reportTableData !== null">
        <button class="b-btn mx-6" @click="exportReportData">
          <dynamic-icon class="b-btn__icon" icon="xls"></dynamic-icon>
          {{$t('CONTENT.reportPage.download_excel')}}
        </button>
        <div class="b-reports__table-wrapper b-reports__table-wrapper_type_short px-6">
          <div class="b-full-table b-reports__table-wrap mt-4">
            <div class="b-reports__table-header-wrap">
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell b-reports__table-cell_type_medium">
                {{$t('CONTENT.reportPage.indicators')}}
              </div>
              <div class="b-full-table__cell b-full-table__header-cell b-reports__table-header-cell">
                {{$t('CONTENT.sum')}}
              </div>
            </div>
            <div class="b-reports__table-row">
              <div class="b-full-table__cell b-reports__table-cell b-reports__table-cell_type_medium">
                {{$t('CONTENT.reportPage.short_term_lease_expense')}}

              </div>
              <div class="b-full-table__cell b-reports__table-cell">
                {{convertDecimalToStringForChart(reportTableData.shortTermLeaseExpense)}}
              </div>
            </div>
            <div class="b-reports__table-row">
              <div class="b-full-table__cell b-reports__table-cell b-reports__table-cell_type_medium">
                {{$t('CONTENT.reportPage.low_value_assets_lease_expense')}}
              </div>
              <div class="b-full-table__cell b-reports__table-cell">
                {{convertDecimalToStringForChart(reportTableData.lowValueAssetsLeaseExpense)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsAPI from "../api/ReportsAPI";
import convertDecimalForChart from "@/utils/converters/convert.decimal.for.chart";

export default {
  props: {
    dataForReport: {
      type: Object,
    }
  },
  data() {
    return {
      error: null,
      reportTableData: null,
    };
  },
  async created() {
    await this.formReport(this.dataForReport);
  },
  watch: {
    dataForReport: {
      handler(newVal) {
        this.formReport(newVal);
      },
      deep: true
    },
  },
  methods: {
    async formReport(data) {
      try {
        this.$loadingManager.addLoadingStep();
        this.error = null;
        this.reportTableData = null;
        this.reportTableData = await new ReportsAPI().getSummaryReportForContractsWithSimplification({
          periodStart: data.periodStart,
          periodEnd: data.periodEnd,
          lesseeId: data.lesseeId
        });
        this.$loadingManager.loadingStepLoaded();
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },
    convertDecimalToStringForChart(decimal) {
      return convertDecimalForChart(decimal);
    },

    async exportReportData() {
      this.error = null;
      try {
        const api = new ReportsAPI();
        const response = await api.exportResultOfSummaryReportForContractsWithSimplification(this.reportTableData);

        let filename = null;
        let filenameInURI = null;

        let headerContentDisposition = response.headers['content-disposition'].split(';');
        for (let i = 0; i < headerContentDisposition.length; i++) {
          let item = headerContentDisposition[i].split('=');
          if(item[0].trim() === 'filename*') {
            filenameInURI = item[1].split("''");
            filename = decodeURIComponent(filenameInURI[1]);
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.error = e;
        console.error(e);
      }
    },
  }
};
</script>
